module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4,
      "id": "sidebar-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('Sidebar')], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "id": "content-container"
    }
  }, [_c('Navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce1bfe36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Frame.vue
// module id = 766
// module chunks = 2